export const version = "networks/5.7.0";
//# sourceMappingURL=_version.js.map